import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqKeywordService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-keywords', query);
  }

  create(body: any) {
    return this.post('/cq-keywords', body);
  }

  find(id) {
    return this.get('/cq-keywords/' + id);
  }

  update(id, body) {
    return this.put('/cq-keywords/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-keywords/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqKeyword.service.ts